export const staticAssetUrl = path => `https://assets.cars24.com/static/c2b-website/${path}`;
